// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","loadingPage":"App_loadingPage__vnhFp","readOnly":"App_readOnly__eZz3l","iframe":"App_iframe__iLq2Q"};